<footer class="footer">
    <div class="container-fluid">
        <div class="footer-content">
            <a class="footer-brand" href="">
                <img src="assets/img/logo-branca.png" alt=""></a>
            <a class="footer-brand" href="">
                <img src="assets/img/Logo-cotin.png" alt=""></a>
        </div>
        <div class="footer-text">{{currentYear}} © COTIN - Todos direitos reservados - Versão {{appVersion}}</div>
    </div>
</footer>